export const orderGroupOperation_Or = 'OR';
export const orderGroupOperation_And = 'AND';
export const orderGroupOperations = [orderGroupOperation_Or, orderGroupOperation_And];
//# sourceMappingURL=types.js.map